module.exports = __webpack_public_path__ + "img/number02.d79c645e.svg";